/**
 * Tracks which tenant a PLATFORM_ADMIN is currently acting as.
 *
 * Populated by the http response interceptor from `meta.actingAsTenant`
 * (per compliance addendum §A.6). Consumed by the topbar indicator so an
 * operator can never accidentally mutate the wrong tenant's data.
 */

export interface ActingTenant {
  id: string;
  code: string;
  name: string;
}

let current: ActingTenant | null = null;
const listeners = new Set<(t: ActingTenant | null) => void>();

export function setActingTenant(next: ActingTenant | null): void {
  // Avoid noisy re-renders when nothing changed.
  if (current?.id === next?.id && current?.code === next?.code) return;
  current = next;
  listeners.forEach((fn) => fn(current));
}

export function getActingTenant(): ActingTenant | null {
  return current;
}

export function subscribeActingTenant(fn: (t: ActingTenant | null) => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
